import React from 'react';

import {months} from '../utils';

const ServiceContainer = ({monthToDisplay, handleChange, name, serviceToDisplay}) => {
  const {credits, usedCredits, monthlyMonitoring} = serviceToDisplay;

  const percentCalc = () => {
    const index = months.findIndex((m) => m === monthToDisplay.month);
    const monthBefore = monthlyMonitoring.find((m) => m.month === months[index - 1]);
    if (monthBefore) {
      if (monthBefore.usedCredits > 0) {
        const percent =
          ((monthToDisplay.usedCredits - monthBefore.usedCredits) /
            monthBefore.usedCredits) *
          100;
        return Math.round(percent);
      } else {
        const percent = (monthToDisplay.usedCredits - monthBefore.usedCredits) * 100;
        return Math.round(percent);
      }
    } else {
      return 0;
    }
  };

  return (
    <div className="service-container">
      <div className="service-top">
        <h4>Crédits restant :</h4>
        <p>{serviceToDisplay.unlimited ? '- -' : credits - usedCredits}</p>
        <p style={{fontWeight: 400}}>
          {serviceToDisplay.unlimited && 'Vous avez un accès illimité à cette feature*'}
        </p>
      </div>
      {!serviceToDisplay.unlimited && (
        <>
          <hr />
          <div className="service-bottom">
            <p>
              Au mois{' '}
              {monthToDisplay.month === 'Août' || monthToDisplay.month === 'Octobre'
                ? `d'${monthToDisplay.month}`
                : `de ${monthToDisplay.month}`}{' '}
              vous avez réalisé
              <span className="service-number">
                {' '}
                {monthToDisplay.usedCredits}{' '}
                {monthToDisplay.usedCredits > 1 ? name.plural : name.singular} !
              </span>
            </p>
            <div className="service-percent-container">
              <p className="service-percent">
                {percentCalc() > 0 ? `+${percentCalc()}` : `${percentCalc()}`} %
              </p>
              <p className="service-percent-subtext">par rapport au mois précédent</p>
            </div>
            <select
              name=""
              onChange={(e) =>
                handleChange(monthlyMonitoring.find((m) => m._id === e.target.value))
              }
              className="service-select input-form-field"
            >
              <option value={monthToDisplay._id}>Sélectionnez une période</option>
              {monthlyMonitoring.map((month) => (
                <option value={month._id} key={month._id}>
                  {month.month}
                </option>
              ))}
            </select>
          </div>
        </>
      )}
    </div>
  );
};

export default ServiceContainer;
